var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 38,
    viewBox: "0 0 26 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Door_Closed",
    "data-name": "Door Closed",
    d: "M25.479,18.9a3.293,3.293,0,0,0-2.811-1.64h-.76V9.07A9.07,9.07,0,0,0,4.562,5.36c0,.01-.01.02-.02.03a9.054,9.054,0,0,0-.46,1.39c-.03.1-.07.19-.09.29a9.15,9.15,0,0,0-.17,1.28c-.01.16-.05.31-.06.47h0V9c0,.02-.01.05-.01.07h.01v8.19h-.42A3.331,3.331,0,0,0,0,20.59V34.66A3.332,3.332,0,0,0,3.331,38H22.668A3.33,3.33,0,0,0,26,34.66h0V20.59A3.092,3.092,0,0,0,25.479,18.9ZM7.793,8.56a4.1,4.1,0,0,1,.1-.48,5.01,5.01,0,0,1,.17-.55,3.454,3.454,0,0,1,.14-.34,4.357,4.357,0,0,1,.33-.6c.04-.07.09-.14.14-.21a5.581,5.581,0,0,1,.49-.6,1.141,1.141,0,0,0,.11-.11,4.318,4.318,0,0,1,.66-.54.351.351,0,0,1,.08-.05,5.625,5.625,0,0,1,.8-.44c.02-.01.03-.01.05-.02a5.906,5.906,0,0,1,.93-.29h.01a4.905,4.905,0,0,1,1.02-.1h.01a5.114,5.114,0,0,1,5.112,5.11v7.92H7.753V8.92C7.763,8.8,7.773,8.68,7.793,8.56Zm3.871,21.58v-2.2h0a2.47,2.47,0,1,1,2.341-4.35,2.588,2.588,0,0,1,.76.63,2.486,2.486,0,0,1,.25,2.72,2.394,2.394,0,0,1-.9.94v2.26a1.223,1.223,0,0,1-2.351.47A1.2,1.2,0,0,1,11.664,30.14Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorClosed);
export default __webpack_public_path__ + "static/media/door_closed.5ce3b9f28b4cbe9db63eaf23d8893aed.svg";
export { ForwardRef as ReactComponent };